import {
  getFirestore,
  connectFirestoreEmulator,
  collection,
  getDocs,
  doc,
  getDoc,
  setDoc,
  deleteDoc,
  serverTimestamp
} from 'firebase/firestore'
import { getStorage, connectStorageEmulator, ref as storageRef, getDownloadURL } from 'firebase/storage'

let firestore
let storage

const setStoresApp = app => {
  firestore = getFirestore(app)
  storage = getStorage(app)
}

const connectStoreEmulators = (host) => {
  connectFirestoreEmulator(firestore, host, 8080)
  connectStorageEmulator(storage, host, 9199)
}

// Add as property to assign on backend
const firestoreCollection = path => collection(firestore, path)
const firestoreDoc = path => doc(firestore, path)
const storageFile = path => storageRef(storage, path)
const getStorageFileUrl = path => getDownloadURL(storageFile(path))

// TODO Use withConverter to convert to local data models
const snapshotDoc = path => getDoc(firestoreDoc(path))

export default {
  serverTimestamp,
  firestoreCollection,
  firestoreDoc
}
export {
  setStoresApp,
  connectStoreEmulators,
  serverTimestamp,
  firestoreCollection,
  getDocs,
  firestoreDoc,
  getDoc,
  setDoc,
  deleteDoc,
  getStorageFileUrl,
  snapshotDoc
}
